module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/title_bg_4-7c0c0679db3c7eadbb2b6e7845917cc7.svg";